module.exports = __webpack_public_path__ + "img/3.4cc81489.png";